module.exports = __webpack_public_path__ + "static/CareLabel-v2-a05d0d27bd241e97bf9491e8421ec3dd.svg";